module.exports = __webpack_public_path__ + "media/images/sp/top/recommend_plan_maedori-c7c703226f7d01f12a51a23fcf1d0cd9.jpg";